import type { DefaultTheme } from 'styled-components/macro';

export const getCustomStyles = (theme: DefaultTheme): Record<string, Record<string, string>> => ({
  overlay: {
    backgroundColor: theme.colors.rgba.variant3,
  },
  spotlight: {
    borderRadius: theme.radius.sm,
  },
});
